module.exports = __webpack_public_path__ + "static/media/envelope.30cc9dbb.svg";